//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationsCounter from '@/components/tasks/ApplicationsCounter.vue'
import AvatarDisplay from '@/components/ui/AvatarDisplay'
import TaskDuration from '@/components/tasks/TaskDuration'
import TaskPrice from '@/components/tasks/TaskPrice'
import TaskTags from '@/components/tasks/TaskTags'
import TaskEscrow from '@/components/tasks/TaskEscrow'
import TaskLikesSmall from '@/components/tasks/TaskLikesSmall'
import { escrowStatuses } from 'ct-constants'
import ClientTrusted from '@/components/client/ClientTrusted'

// noinspection JSUnusedGlobalSymbols
export default {
  components: {
    ClientTrusted,
    TaskLikesSmall,
    TaskEscrow,
    ApplicationsCounter,
    TaskDuration,
    TaskPrice,
    TaskTags,
    AvatarDisplay
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      avatarOptions: {
        resize: {
          width: 100,
          height: 100
        }
      }
    }
  },
  computed: {
    taskData () {
      return this.task._source
    },
    timePostedDate () {
      return this.$moment(this.taskData.timePosted).format('MMM Do')
    },
    clientUrl () {
      return this.localePath(`/clients/${this.taskData.postedBySlug}/${this.taskData.postedById}`)
    },
    avatar () {
      return {
        fileName: this.taskData.postedByAvatar
      }
    },
    taskClasses () {
      const classes = []
      if (this.taskData.visibility > 0) {
        classes.push('visibility-boosted')
      }
      if (this.taskData.escrowShowcase) {
        classes.push('escrow-set')
      }
      return classes
    },
    /**
     * Is escrow set and visible
     * @returns {boolean}
     */
    escrowVisible () {
      return this.taskData?.escrowStatus === escrowStatuses.ESCROW_SET && this.taskData?.escrowBalance > 0
    }
  }
}
